import axios from 'axios';

let url = 'https://api.clinkapp.de/api/';

if (typeof window !== 'undefined' && window.location.hostname === 'staging.clinkapp.de') {
    url = 'https://api-staging.clinkapp.de/api/';
} else if (process.env.NODE_ENV !== 'production') {
    url = 'http://localhost:3002/api/'; // Fallback for local development
}

export default {
    getUser() {
        return axios
            .get(url + 'return-user/')
            .then(response => response.data);
    },
    login(credentials) {
        return axios
            .post(url + 'login/', credentials)
            .then(response => response.data);
    },
    signUp(credentials) {
        return axios
            .post(url + 'sign-up/', credentials)
            .then(response => response.data);
    },
    createPool(data) {
        return axios
            .post(url + 'create-pool/', data)
            .then(response => response.data);
    },
    joinPool(data) {
        return axios
            .post(url + 'join-pool/', data)
            .then(response => response.data);
    },
    leavePool(data) {
        return axios
            .post(url + 'leave-pool/', data)
            .then(response => response.data);
    },
    getPool(data) {
        return axios
            .post(url + 'get-pool/', data)
            .then(response => response.data);
    },
    getUserAdministratedPools() {
        return axios
            .get(url + 'get-user-administrated-pools/')
            .then(response => response.data);
    },
    getUserJoinedPools() {
        return axios
            .get(url + 'get-user-joined-pools/')
            .then(response => response.data);
    },
    getUserProfileFromPool(data) {
        return axios
            .post(url + 'get-user-profile-from-pool/', data)
            .then(response => response.data);
    },
    submitUserProfile(data) {
        return axios
            .post(url + 'submit-user-profile', data)
            .then(response => response.data);
    },
    matchGetNextProfiles(data) {
        return axios
            .post(url + 'match-get-next-profiles', data)
            .then(response => response.data);
    },
    matchCastVote(data) {
        return axios
            .post(url + 'match-cast-vote', data)
            .then(response => response.data);
    },
    getUserVotes(data) {
        return axios
            .post(url + 'user-votes', data)
            .then(response => response.data);
    },
    getUserMatches(data) {
        return axios
            .post(url + 'user-matches', data)
            .then(response => response.data);
    },
    getChat(data) {
        return axios
            .post(url + 'get-chat', data)
            .then(response => response.data);
    },
    sendChat(data) {
        return axios
            .post(url + 'send-chat', data)
            .then(response => response.data);
    },
    uploadImage(data, headers) {
        return axios
            .post(url + 'upload', data, headers)
            .then(response => response.data)
    },
    getProfileImages(data) {
        return axios
            .get(url + 'profile-images', { params: data })
            .then(response => response.data)
    },
    getImage(data) {
        return axios
            .get(url + 'get-image', { responseType: 'blob', params: data })
            .then(response => response.data)
    },
    removeImage(data) {
        return axios
            .delete(url + 'remove-image', { params: data })
            .then(response => response.data)
    },
    getPushActivationStatus() {
        return axios
            .get(url + 'check-push-activation/')
            .then(response => response.data);
    },
    getSecretContent() {
        return axios.get(url + 'secret-route/').then(response => response.data);
    },
    getAvailableDrinks(data) {
        return axios
            .get(url + 'available-drinks', { params: data })
            .then(response => response.data)
    },
    getAvailableDrinkTypes(data) {
        return axios
            .get(url + 'available-drink-types', { params: data })
            .then(response => response.data)
    },
    getAvailableDrinksOfType(data) {
        return axios
            .get(url + 'available-drinks-of-type', { params: data })
            .then(response => response.data)
    },
    addNewDrinkType(data) {
        return axios
            .post(url + 'add-drink-type', data)
            .then(response => response.data)
    },
    addNewDrink(data) {
        return axios
            .post(url + 'add-drink', data)
            .then(response => response.data)
    },
    updateDrink(data) {
        return axios
            .post(url + 'update-drink', data)
            .then(response => response.data)
    },
    deleteDrinkType(data) {
        return axios
            .post(url + 'delete-drink-type', data)
            .then(response => response.data)
    },
    deleteDrink(data) {
        return axios
            .post(url + 'delete-drink', data)
            .then(response => response.data)
    },

    logDrink(data) {
        return axios
            .post(url + 'log-drink', data)
            .then(response => response.data)
    },
    updateLog(data) {
        return axios
            .post(url + 'update-log', data)
            .then(response => response.data)
    },
    deleteLog(data) {
        return axios
            .post(url + 'delete-log', data)
            .then(response => response.data)
    },
    getPoolDashboardStats(data) {
        return axios
            .post(url + 'get-pool-dashboard-stats', data)
            .then(response => response.data)
    },
    getUserLoggedDrinks(data) {
        return axios
            .get(url + 'user-logged-drinks', { params: data })
            .then(response => response.data)
    },
    getUsersInPool(data) {
        return axios
            .get(url + 'users-in-pool', { params: data })
            .then(response => response.data)
    },
    getLastUsedName() {
        return axios
            .get(url + 'get-last-profile-name')
            .then(response => response.data)
    },

    getPoolStatistics(data) {
        return axios
            .get(url + 'pool-statistics', { params: data })
            .then(response => response.data)
    },
    getPoolLogs(data) {
        return axios
            .post(url + "get-pool-logs", data)
            .then((response) => response.data);
    },
    getPoolDashboardStatistics(data) {
        return axios
            .post(url + "get-pool-dashboard-statistics", data)
            .then((response) => response.data);
    },
    createStripeSession(data) {
        return axios
            .post(url + 'stripe/create-checkout-session', data)
            .then(response => response.data);
    },
    changePassword(data) {
        return axios
            .post(url + 'change-password', data)
            .then(response => response.data);
    },
    requestPasswordReset(data) {
        return axios
            .post(url + 'forgot-password', data)
            .then(response => response.data);
    },
    resetPassword(data) {
        return axios
            .post(url + 'reset-password', data)
            .then(response => response.data);
    },
    getGlobalStats() {
        return axios
            .get(url + 'admin/global-stats')
            .then(response => response.data);
    }
};

